import React from "react";
import styles from './site.module.scss';

const Footer = () => {
    return (
        <div className={styles.footer}>
            <div className={styles.footerItem}>
            </div>
            <div className={styles.footerItem}>
            </div>
        </div>);
};

export default Footer;